export default class StatusMessage {
  description: string | null;
  detailedDescription: string | null;
  responseCode: string | null;

  constructor() {
    this.description = null;
    this.detailedDescription = null;
    this.responseCode = null;
  }

  static fromJSON(json: Record<string, string>): StatusMessage {
    const statusMessage = new StatusMessage();
    statusMessage.description = json.description;
    statusMessage.detailedDescription = json.detailedDescription;
    statusMessage.responseCode = json.responseCode;

    return statusMessage;
  }
}
